<script>
    import {push} from 'svelte-spa-router'
    import { translations, current_lang } from '../stores.js';

    export let article;

    let id = article.id;
    let image = null;

    if(article.mobilePictureUrl != null && article.mobilePictureUrl != ""){
        image = article.mobilePictureUrl
    }else if(article.fullPictureUrl != null && article.fullPictureUrl != ""){
        image = article.fullPictureUrl
    }

    let title = article.title;
    let article_date = article.date
    import WaitingPlaceholderBox from './WaitingPlaceholderBox.svelte'

    //routing to single article page
    function show_article(){
        push('/article/'+id);
    }

    import { afterUpdate } from 'svelte';

    let image_load = null;
    afterUpdate(() => {
        id = article.id;
        if(article.mobilePictureUrl != null && article.mobilePictureUrl != ""){
            image = article.mobilePictureUrl
        }else if(article.fullPictureUrl != null && article.fullPictureUrl != ""){
            image = article.fullPictureUrl
        }
        title = article.title;
        article_date = article.date

        image_load = image_get();
    });

    async function image_get() { 
        if(image == null || image == ""){
            return;
        }

        const img = new Image();
        img.src = image;

        const res = await img.decode()
        .then(() => {
            return img.src;
        })
        .catch((encodingError) => {
            // Do something with the error.
        })

        return res;
    }
</script>
   
    <div class="news-article-box" on:click={show_article}>


        {#if image != null && image != ""}
            {#await image_load}
                <WaitingPlaceholderBox height={240} margin_bottom={0} />
            {:then img_src}
            {#if img_src != null && img_src != ""}
                <div class="picture" style="background-image: url({img_src});">
                    <div class="date">{article_date}</div>
                </div>
            {:else}
                <div class="picture-placeholder">
                    <div class="date">{article_date}</div>
                    <span class="offline-notice">
                        {$translations["PIC_NOT_LOADED_OFFLINE"][$current_lang]}
                    </span>
                </div>
            {/if}
            {:catch error}
                <p>{error}</p>
            {/await}
        {/if}
        <div class="title-row">
            <h2>{title}</h2>
        </div>
    </div>
   
<style>
    .news-article-box{
        width: 100%;
        position: relative;
        cursor: pointer;
    }

    .picture{
        background-size: cover;
        background-position: center center;
        width: 100%;
        aspect-ratio: 1 / 1;
    }

    .picture-placeholder{
        background-color: var(--dark-color);
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        aspect-ratio: 1 / 1;
    }

    .picture-placeholder span{
        color: #fff;
        font-weight: 500;
        font-size: 0.8em;
        font-family: "futura-pt","Roboto Condensed",Arial;
        max-width: 210px;
        text-align: center;
    }

    .date{
        position: absolute;
        top: 0;
        left: 0;
        background: var(--theme-color-1);
        color: #fff;
        padding: 5px 20px;
        font-weight: 700;
        font-size: 1em;
        font-family: "futura-pt","Roboto Condensed",Arial;

        border-radius: 0 0 2px 0;
    }

    .title-row{
        position: relative;
        margin: 0 auto;
        height: auto;
        padding: 15px;
        text-align: left;
        min-height: 0px;
        background-color: var(--light-color);
        display: flex;
        align-items: left;
        justify-content: center;
        flex-direction: column;
    }
    .title-row h2{
        font-size: 1.4em;
        color: #282828;
        margin: 0;
    }
</style>